import { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { UserData } from '../../types';

const PLAN_COLORS: Record<string, string> = {
  'Free Trial': '#9ca3af',
  'Essential': '#3b82f6',
  'Professional': '#7c3aed',
  'Starter': '#10b981',
  'Scholar': '#f59e0b',
};

interface SubscriptionChartProps {
  users: UserData[];
}

export function SubscriptionChart({ users }: SubscriptionChartProps) {
  const data = useMemo(() => {
    const counts: Record<string, number> = {
      'Free Trial': 0,
      'Essential': 0,
      'Professional': 0,
      'Starter': 0,
      'Scholar': 0,
    };

    users.forEach(user => {
      if (!user.subscribed) {
        counts['Free Trial']++;
      } else if (user.plan === 'starter') {
        counts['Starter']++;
      } else if (user.plan === 'scholar') {
        counts['Scholar']++;
      } else if (user.plan === 'professional') {
        counts['Professional']++;
      } else {
        counts['Essential']++;
      }
    });

    return Object.entries(counts)
      .filter(([, value]) => value > 0)
      .map(([name, value]) => ({ name, value }));
  }, [users]);

  const renderLabel = ({ name, percent }: { name: string; percent: number }) =>
    `${name} ${(percent * 100).toFixed(0)}%`;

  return (
    <div className="chart-card">
      <h3>Plan Distribution</h3>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={renderLabel}>
            {data.map((entry, i) => (
              <Cell key={i} fill={PLAN_COLORS[entry.name] || '#6b7280'} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
